import React, { useState } from "react";
import styles from "./ResetPassword.module.css";
import { useLocation } from "react-router-dom";
import i18n from "../Services/i18n";
import AccountService from "../Services/accountService";
import PasswordInput from "../LayoutComponents/PasswordInput";
const PASSWORD_RGX =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d_\W]{8,}$/;

const ResetPassword = () => {
  const location = useLocation();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const isPasswordValid = PASSWORD_RGX.test(password);
  const passwordsMatch =
    password.trim() !== "" && password.trim() === confirmPassword.trim();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const params = new URLSearchParams(location.search);
    await AccountService.ChangePasswordFromRequest(
      params.get("x"),
      params.get("y"),
      params.get("z"),
      password
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.loginWrapper}>
        <form className={styles.loginForm} onSubmit={handleSubmit}>
          <p>
            <strong>{i18n.t("ChangePassword.info")}</strong>
          </p>
          <p className={styles.validationMessage}>
            {i18n.t("ChangePassword.passwordvalidation")}
          </p>

          <label className={styles.loginLabel}>
            {i18n.t("ChangePassword.RequestNewPassword")}
            <PasswordInput
              className={styles.loginInput}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>

          <label className={styles.loginLabel}>
            {i18n.t("ChangePassword.RequestConfirmNewPassword")}
            <PasswordInput
              className={styles.loginInput}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </label>

          <div className={styles.loginFormFooter}>
            <button
              className={styles.loginButton}
              disabled={!isPasswordValid || !passwordsMatch}
              type="submit">
              {i18n.t("ChangePassword.RequestNewPasswordSubmitButton")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
